import { render, staticRenderFns } from "./TaxRuleEditor.vue?vue&type=template&id=42106660&scoped=true"
import script from "./TaxRuleEditor.vue?vue&type=script&lang=js"
export * from "./TaxRuleEditor.vue?vue&type=script&lang=js"
import style0 from "./TaxRuleEditor.vue?vue&type=style&index=0&id=42106660&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42106660",
  null
  
)

export default component.exports